import { schema } from "normalizr";

const availableReaction = new schema.Entity(`available_reactions`, {}, { idAttribute: `type` });
const arrayOfAvailableReactions = [availableReaction];

export { availableReaction, arrayOfAvailableReactions };
